import {
  type Action,
  type Transfer,
  createGeneralActionsByTransfers,
} from '@0xtorch/core'
import type { TransactionDecoded } from '../../../types/transactionDecoded'

type CreateActionsByGasAnalyzerParameters = {
  readonly transaction: TransactionDecoded
  readonly transfers: readonly Transfer[]
  readonly accountIds: Set<string>
  readonly source: string
}

export const createActionsByGeneralAnalyzer = ({
  transaction,
  transfers,
  accountIds,
  source,
}: CreateActionsByGasAnalyzerParameters): readonly Action[] => {
  // 汎用分析してアクション作成
  const actions = createGeneralActionsByTransfers({
    transfers,
    accountIds,
    source,
    timestamp: transaction.timestamp,
  })
  for (const action of actions) {
    action.app = transaction.to?.app ?? transaction.from.app
  }
  return actions
}
